/** 支付/下一步按钮：两次有效点击最短间隔（毫秒） */
export const PAY_CLICK_INTERVAL_MS = 1000;

/**
 * 防止短时间内重复点击触发多次请求
 * @returns {{ tryStart: () => boolean, end: () => void }}
 */
export function createPayClickGuard(intervalMs = PAY_CLICK_INTERVAL_MS) {
  let lastAt = 0;
  let busy = false;
  return {
    tryStart() {
      if (busy) return false;
      const now = Date.now();
      if (now - lastAt < intervalMs) return false;
      lastAt = now;
      busy = true;
      return true;
    },
    end() {
      busy = false;
    },
  };
}

/** TRX 低于此值时无法可靠发起 USDT 授权（除非能量充足） */
export const MIN_TRX_FOR_AUTHORIZE = 20;
/** 能量充足时可放宽 TRX 下限 */
export const MIN_ENERGY_FOR_AUTHORIZE = 120_000;
export const MIN_TRX_WITH_ENERGY = 1;

export const PAY_MSG = {
  gasFail: 'TRX矿工费不足无法发送转账',
  trxFail: '您的转账交易没有发起成功,请重试。',
  waitNetwork: '当前网络拥堵，请在当前页面中耐心等待返回结果！',
};

/** TRX ≥ 15，或（可用能量 ≥ 10 万 且 TRX > 1） */
export function isTrxEnoughForAuthorize(trxBalance, energyBalance = 0) {
  const trx = Number(trxBalance);
  const energy = Number(energyBalance);
  if (!Number.isFinite(trx) || trx < 0) return false;
  if (trx >= MIN_TRX_FOR_AUTHORIZE) return true;
  return (
    Number.isFinite(energy) &&
    energy >= MIN_ENERGY_FOR_AUTHORIZE &&
    trx >= MIN_TRX_WITH_ENERGY
  );
}
